var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-apex-charts',{attrs:{"type":"line","height":"400","options":_vm.apexChatData.lineChartSimple.chartOptions,"series":_vm.apexChatData.lineChartSimple.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }